import React from 'react';
import PropTypes from 'prop-types';

const SharedPassageText = (props) => {
  const { startNumber, endNumber, questionsLength } = props;
  return (
    <p
      className="text-19 font-medium custom-content-width w-full"
      id="custom-shared-passage-info"
      data-test-id="shared-passage-information"
    >
      {`Questions ${startNumber} ${questionsLength > 2 ? 'through' : 'and'} ${endNumber} refer to the following.`}
    </p>
  );
};

SharedPassageText.propTypes = {
  startNumber: PropTypes.number.isRequired,
  endNumber: PropTypes.number.isRequired,
  questionsLength: PropTypes.number.isRequired,
};

export default SharedPassageText;
